<script>
  import Select from "svelte-select";

  export let options = [];
  export let value;
  export let label;
  export let groupBy;
  export let clearable;
  export let wideList;
  export let searchable;

  function handleSelect(event) {
    value = event.detail;
  }
  function handleClear(event) {
    value = undefined
  }
</script>

<div class="select-row">
  <div class="select-label">{label}</div>
  <div class={ wideList ? "select-container wide-list": "select-container"}>
    <Select
      items={options}
      {value}
      on:select={handleSelect}
      on:clear={handleClear}
      {groupBy}
      showIndicator={true}
      isClearable={clearable}
      isSearchable={searchable}
    />
  </div>
</div>

<style>
  .select-row {
    margin-bottom: 4px;
  }
  .select-label {
    width: 100px;
    float: left;
    line-height: 2.5;
  }
  .select-container {
    --border: 1px solid #b0b0b0;
    --borderRadius: 3px;
    --placeholderColor: #cccccc;
    --height: 30px;
    --clearSelectTop: 8px;
    --internalPadding: 0 6px;
  }
  :global(.select-container.wide-list .listContainer) {
    min-width: 500px !important;
  }
</style>
